$(document).ready(function(){
  if($('body.product')){  
    let desc_wrap = $('.description_content');
    desc_wrap && desc_wrap.each(function(){
      $(this).wrapInner(`<div class="desc_content"></div>`);
      $(this).append(`<div id="desc_toogler"><a href="#">Show more</a></div>`);
      let heightContent = $(this).height();
      if(heightContent > 200){
        desc_wrap.addClass("showMore");
        $('.desc_content').addClass("hideContent");
      }
      
    })
    if($("#desc_toogler a")){
      $("#desc_toogler a").on("click", function(e) {
        e.preventDefault();
        let $this = $(this); 
        let $content = $this.parent().prev(".desc_content");
        let linkText = $this.text().toUpperCase();    
        
        if(linkText === "SHOW MORE"){
          linkText = "Show less";
          $content.toggleClass("hideContent");
        } else {
          linkText = "Show more";
          $content.toggleClass("hideContent");
        };
    
        $this.text(linkText);
      });
    }

    const defaultNoticeInnerHTML = `<p class="customily_modal_preview--title">Please check the preview carefully</p> <p class="customily_modal_preview--notice_content"><em>Make sure the below customization is correct to receive your item faster</em></p>`
    function handleFakeBtnClick(t) {
      t.stopPropagation(),
        document.querySelector(".btn-preview-add-to-cart").classList.add("running");
      document.querySelector(".add_to_cart_js").click();
    }
    function mainFunc(item) {
      if (item.classList !== null && item.classList !== void 0) {
        if (item.classList.contains('canvas-container')) {
          var t = document.querySelector(".add_to_cart_js");
          
          e = document.querySelector(".customily-modal-preview-only .main");
          t.classList.add("btn-preview-add-to-cart");
          e.appendChild(t);
          t.addEventListener("click", function (t) {
            return handleFakeBtnClick(t);
          });
          const formWrapper = document.querySelector('.product_form');
          
          var modifyNoticeEl = document.createElement('div');
          modifyNoticeEl.className = 'customily_modal_preview--modify_notice';
          
          modifyNoticeEl.innerHTML = defaultNoticeInnerHTML;
          e.appendChild(modifyNoticeEl)
        }
      }
    }  
    (function () {
      try {
        const observer = new MutationObserver(function (t) {
          t.forEach(function (t) {
            if (t.addedNodes) {
              for (var r = 0; r <t.addedNodes.length; r++) {
                var e = t.addedNodes[r];
                mainFunc(e);
              }
            }
      
          });
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }

  function personalisation() {
    function handleChecked(el){
      if (el.val() === "no") {
        el.parents(".product_properties").find(".properties_custom__error").hide();
        el.parents(".layoutInput").find(".noCustom").val("Customer requires no text").removeAttr("disabled");
        el.parents(".layoutInput").find(".properties_custom input").attr("disabled", "disabled").hide();
        el.parents(".layoutInput").find(".properties_custom").hide();
        $('.ajax-submit').prop("disabled", false);
      } else {
        el.parents(".product_properties").find(".properties_custom__error").hide();
        el.parents(".layoutInput").find(".noCustom").attr("disabled", "disabled").val("");
        el.parents(".layoutInput").find(".properties_custom input").removeAttr("disabled").show();
        el.parents(".layoutInput").find(".properties_custom").show();
        $('.ajax-submit').prop("disabled", true);
      }
    }
  
    $('body').on("keyup", ".properties_custom input", function () {
      const _this = $(this);
      const maxLength = $(this).attr('maxlength');
      if ($(this).val().length > maxLength) {
        $(this).val($(this).val().slice(0, maxLength));
      }
      
      if (_this.val().trim() == "") {
        _this.parents(".product_properties").find(".properties_custom__error").show();
        _this.css("border", "1px solid red");
        $('.ajax-submit').prop("disabled", true);
        flag = false;
      } else {
        _this.parents(".product_properties").find(".properties_custom__error").hide();
        _this.css("border-color", "#e3e3e3");
        $('.ajax-submit').prop("disabled", false);
      }
    });
  
    $(".btn-radio__checked").each(function () {
      if ($(this).val() === "no") {
        $(this).attr("checked", true);
        handleChecked($(this));
      }
    });
  
    $(document).on("change", ".btn-radio__checked", function () {
      handleChecked($(this));
    });
  }

  if (window.PXUTheme.theme_settings.product_form_style === 'radio') {
    const engraved = $('.swatch[data-option-name="engraved"]');
    function engravedFnc(){
      const html = `<div class="product_properties engraving_input" style="width: 100%;"><div class="properties_custom"><span class="properties_custom__error" style="font-size: 13px; color: red; display: none;" class="properties_custom__error">This field is required</span><input required maxlength="16" style="display:block; width: 100%;" type="text" class="form-control form-field-input" id="engraving_custom" placeholder="Enter your text here" name="properties[Engraved]" data-error="Please enter a your text."></div></div>`;
      $('body').on('change', '.swatch :radio', function swatchLogic() {
        const $this2 = $(this);
        const optionValue = $this2.val().toLowerCase();
        const swatchParent = $this2.closest('.swatch');
        const optionName = swatchParent.data('option-name');
  
        if(optionName === "engraved" && optionValue === 'yes'){
          if(swatchParent.children('.engraving_input').length < 1){
            swatchParent.append(html);
          }
        } else {
          if(swatchParent.children('.engraving_input').length > 0){
            swatchParent.children('.engraving_input').remove();
            $('.ajax-submit').prop("disabled", false);
          }
        }
      });

      const engraving = engraved.find('input:checked');
      const optionValue = engraving.val().toLowerCase();
      const swatchParent = engraved;
      const optionName = swatchParent.data('option-name');
      if(optionName === "engraved" && optionValue === 'yes'){
        if(swatchParent.children('.engraving_input').length < 1){
          swatchParent.append(html);
        }
      }
      $('.ajax-submit').on('click', function(){
        const engravingInput = $('.engraving_input input');
        if(engravingInput){
          if (engravingInput.val().trim() === "") {
            $(this).prop("disabled", true);
            $('.properties_custom__error').show();
            engravingInput.focus();
            engravingInput.css("border", "1px solid red");
          }
        }
      });
    }
    engraved && engraved.length && engravedFnc();
  }

  personalisation();
});

const dataLayerATC = function(cart){
  const data = [{
    item_id: cart.product_id,
    item_variant_id: cart.variant_id,
    item_name: cart.product_title || cart.title,
    item_brand: cart.vendor,
    item_category: cart.product_type,
    price: cart.price/100.00,
    quantity: cart.quantity,
    variant_title: cart.variant_title
  }]
  
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      currency: window.PXUTheme.currency.default_currency,
      value: cart.final_line_price/100.00,
      items: data
    }
  });
}

function dataLayerAtc(action){
  const $addToCartForm = action.closest('form');
  const $addToCartBtn = $addToCartForm.find('.add_to_cart');

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: $addToCartForm.serialize(),
    success(addCart) {
      dataLayerATC(addCart);
    }
  });
}

const elAtcTypeBtn = $('.add_to_cart_js[type="button"]');
const elAtcTypeSubmit = $('.add_to_cart_js[type="submit"]');
if(elAtcTypeBtn){
  $(document).on('click', '.add_to_cart_js', function (e) {
    dataLayerAtc($(this));
  });
}
if(elAtcTypeSubmit){
  $(document).on('submit', '.add_to_cart_js', function (e) {
    dataLayerAtc($(this));
  });
}

